import { useMutation } from '@tanstack/vue-query';
import { dscvrIcApi } from '@/shared/api';

export const useRemoveContentMutation = () => {
  return useMutation({
    mutationKey: ['remove-content-mutation'],
    mutationFn: (contentId: bigint) => dscvrIcApi.post.removeContent(contentId),
  });
};
